import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { ResponseHikiatekinSetting, ResponseHikiatekinSettingItem } from '@/repositories/fuzoku-meisai/junsoku/data'

export interface HikiatekinRepository {
  list (): Promise<ResponseHikiatekinSetting>;

  save (param: ResponseHikiatekinSettingItem[]): Promise<void>;
}

export type PostParamItem = {
  itemName: string;
  summary: string;
  positiveKmkList: Kamoku[];
  negativeKmkList: Kamoku[];
}

export class HikiatekinRepositoryImpl implements HikiatekinRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/hikiatekin`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseHikiatekinSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: ResponseHikiatekinSettingItem[]): Promise<void> {
    const postParams: PostParamItem[] = param.map(p => {
      return {
        itemName: p.itemName,
        summary: p.summary,
        positiveKmkList: p.positiveKmkSettings.targets,
        negativeKmkList: p.negativeKmkSettings.targets
      }
    })
    await this.http.post(this.baseUrl, postParams)
  }
}
